export default __webpack_public_path__ + "cdff0d18eb290f21633600d16c24d5b6.wav";